// extracted by mini-css-extract-plugin
module.exports = {"BestPracticePage":"BestPracticePage_BestPracticePage__PZzBc"};